import 'uuid';
export class ClientsService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async saveClient(client) {
        if (client) {
            const response = await this.apiService.post('client', client);
            if (!response.ok) {
                throw new Error(`Error al guardar el cliente.`);
            }
            localStorage.setItem('currentClient', JSON.stringify(client));
            return true;
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
    getClient() {
        if (localStorage.getItem('currentClient') == 'null')
            return null;
        return JSON.parse(localStorage.getItem('currentClient'));
    }
    savePhone(phone) {
        const oldPhone = localStorage.getItem('currentPhone');
        if (oldPhone == phone)
            return;
        localStorage.setItem('currentPhone', phone);
        return;
    }
    getClientPhone() {
        const oldPhone = localStorage.getItem('currentPhone');
        return oldPhone;
    }
}
